import { render, staticRenderFns } from "./ImageSelection.vue?vue&type=template&id=56efad34"
import script from "./ImageSelection.vue?vue&type=script&lang=js"
export * from "./ImageSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports